<script>
export default {
    props: {
        layout: {
            type: Object,
            default: function() {
                return {
                    label: 6,
                    wrapper: 16
                };
            }
        },
        id: {
            type: String,
            default: ""
        },
        parameter: {
            type: String,
            default: ""
        },
        weight: {
            type: String,
            default: ""
        },
        isAspect: {
            type: Boolean,
            default: false
        },
    },
    created() {
        // if (this.editing) {
        //     this.preload = true;
        //     this.getItem();
        // }
    },
    computed: {
        editing() {
            return this.aspect !== "";
        },
        isEdit() {
            return this.parameter !== "";
        }
    },
    data() {
        return {
            formLayout: 'horizontal',
            form: this.$form.createForm(this),
            preload: false,
            processing: false,
            item: {}
        };
    },
    methods: {
        handleSubmit(e) {
            e.preventDefault(e);

            this.form.validateFields((err, formData) => {
                if (!err) {
                    this.processing = true;

                    let promise;

                    if (this.editing) {
                        if(!this.isAspect){
                            promise = this.$http.put(
                                this.routeUri("api.classical.weighting.objective.update", {
                                    objective: this.id
                                }),
                                formData
                            );
                        }else{
                            promise = this.$http.put(
                                this.routeUri("api.classical.weighting.update", {
                                    category: this.id
                                }),
                                formData
                            );
                        }
                    } else {
                        promise = this.$http.post(
                            this.routeUri("backend.setting.parameters.modul-assesment"),
                            formData
                        );
                    }

                    promise
                        .then(response =>
                            this.handleSuccessResponse(response.data)
                        )
                        .catch(error =>
                            this.handleResponseError(error.response.data)
                        )
                        .finally(() => (this.processing = false));
                }
            });
        },
        handleSuccessResponse(data) {
            var successMessage = "Data berhasil diproses!";

            if (typeof data.successMessage != "undefined") {
                successMessage = data.successMessage;
            }

            this.$notification.success({
                message: "Sukses!",
                description: successMessage
            });
            setTimeout(() => this.$emit("handleClose", true), 2000);
        },
        handleResponseError(data) {
            if (data.hasOwnProperty("errors")) {
                for (let key in data.errors) {
                    this.$notification.error({
                        message: "Gagal proses " + key,
                        description: Object.values(data.errors[key])
                    });
                }
            } else {
                this.$notification.error({
                    message: "Gagal proses",
                    description: "Data tidak dapat diproses."
                });
            }
        },
        handleClose() {
            this.$emit("handleClose", false);
        }
    },
    watch: {
        item: function(value) {
            this.form.getFieldDecorator("name", { initialValue: value.name });
            this.form.getFieldDecorator("score_portion", { initialValue: value.score_portion });
        }
    }
};
</script>

<template>
    <a-card type="inner" size="small">
        <a-skeleton :loading="preload" active>
            <a-form :form="form" :layout="formLayout" @submit="handleSubmit">
                <a-form-item label="Nama">
                    <a-input
                        placeholder="Nama"
                        :disabled="isEdit && isAspect"
                        v-decorator="[
                            'name',
                            {
                                rules: [
                                    {
                                        required: true,
                                        message: 'Field ini wajib diisi'
                                    }
                                ],
                                initialValue: parameter
                            }
                        ]"
                    />
                </a-form-item>

                <a-form-item label="Bobot">
                    <a-input
                        :min="0"
                        v-decorator="[
                            'weight',
                            { initialValue: weight }
                        ]"
                    />
                </a-form-item>

                <a-form-item>
                    <a-row type="flex" justify="center" align="top">
                        <a-col>
                            <a-space>
                                <a-button
                                    type="primary"
                                    html-type="submit"
                                    :loading="processing"
                                    :disabled="processing"
                                    >Submit</a-button>
                                <a-button
                                    @click="handleClose"
                                    :loading="processing"
                                    :disabled="processing"
                                    >Tutup</a-button>
                            </a-space>
                        </a-col>
                    </a-row>
                </a-form-item>
            </a-form>
        </a-skeleton>
    </a-card>
</template>
